<app-header [label]="page_label" sub_label="Student Mapping"></app-header>

<div class="h-[calc(100vh-100px)] bg-white shadow-md rounded-lg flex flex-col">
  <form [formGroup]="form" class="flex flex-col flex-1">

    <div class="flex-1 p-6">
      <div class="grid grid-cols-2 gap-6">
        <app-select-input label="University" class="w-full" [is_required]="true" formControlName="university_id" [options]="ds.dropdown_list?.university_list" (valueChange)="onUniversityOrYearChange()"></app-select-input>
        <app-select-input label="Academic Year" class="w-full" [is_required]="true" formControlName="academic_year_id" [options]="ds.dropdown_list?.academic_list" (valueChange)="onUniversityOrYearChange()"></app-select-input>
        <app-select-input label="Exam" class="w-full" [is_required]="true" formControlName="exam_id" [options]="filtered_exams_for_form" (valueChange)="onExamChange()"></app-select-input>
        <app-select-input [is_multiple]="true" label="Subject" class="w-full" [is_required]="true" formControlName="subject_ids" [options]="filtered_subjects_for_exam"></app-select-input>
        <app-select-input label="Unique Id" class="w-full" [is_required]="true" formControlName="student_id" [options]="filtered_students_for_form"></app-select-input>
        <app-text-input [is_required]="true" class="w-full" label="Roll No." formControlName="roll_number"></app-text-input>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-end items-center gap-3 px-6 py-4 border-t border-gray-100 sticky bottom-0 bg-white">
      <button type="button" (click)="gs.go_back()" class="px-6 py-2.5 text-sm text-gray-700 bg-white border border-gray-300 rounded-full hover:bg-gray-50 transition-colors">
        Discard
      </button>
      <button type="button" (click)="submit()" [disabled]="isSubmitting" class="px-8 py-2.5 text-sm text-white bg-[#3F41D1] rounded-full hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors">
        {{ isSubmitting ? 'Saving...' : (selected_item?.id ? 'Update' : 'Save') }}
      </button>
    </div>

  </form>
</div>
